import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AlertType } from '../../../services/alert/alert.interface';
import { AlertService } from '../../../services/alert/alert.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Relationship, ApplicantRequest, ApplicantIndividualIdentification, ApplicantIndividualContact, ApplicantIndividual, ApplicantOrganisationIdentification } from '../../../services/http/applicants/applicants.interface';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';
import { Attachment } from '../../../services/http/attachments/attachments.interface';
import { CodeName, RequestDate } from '../../../services/http/common.http.interface';
import { Country } from '../../../services/http/countries/countries.interface';
import { CountriesService } from '../../../services/http/countries/countries.service';
import { Municipality, MunicipalityManagement, MunicipalityProvinceData } from '../../../services/http/municipalities/municipalities.interface';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';
import { Province } from '../../../services/http/provinces/provinces.interface';
import { ProvincesService } from '../../../services/http/provinces/provinces.service';
import { LoaderService } from '../../../services/loader/loader.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DialogService } from '../../../services/dialog/dialog.service';
import { ExceptionsService } from '../../../services/http/exceptions/exceptions.service';
import { VehicleRquest, VehicleType } from '../../../services/http/vehicles/vehicles.interface';
import { ExceptionCreate } from '../../../services/http/exceptions/exceptions.interface';
import { CustomInputFileComponent } from '../../../components/custom-input-file/custom-input-file.component';
import { VehiclesService } from '../../../services/http/vehicles/vehicles.service';
import { AttachmentUtil } from '../../../services/utils/attachment.utils';

@Component({
  selector: 'app-register-foreign',
  standalone: true,
  imports: [FormsModule, CommonModule, RouterLink, CustomInputFileComponent],
  templateUrl: './register-foreign.component.html',
  styleUrl: './register-foreign.component.scss'
})
export class RegisterForeignComponent {
  relationships: Relationship[] = [];
  countries: Country[] = [];
  provinces: Province[] = [];
  municipalities: MunicipalityProvinceData[] = [];
  applicant: ApplicantRequest = {
    identifier: "",
    applicantType: "Individual",
    individual: undefined,
    company: undefined,
    represented: undefined,
    password: "3R9i+mCo8>e8", // Todo: quitar del registro no se usa pass
    comments: "",
    attachments: [] as Attachment[],
    flags: {
      email: false,
      sms: false,
      personal: false,
      privacity: false,
      protection: false,
      veracity: false,
      language: 'en-GB',
      vehicleDocumentation: false
    }
  }
  user: string = "";
  email: string = "";
  password: string = "";
  password2: string = "";
  confirmEmail: string = "";
  isValid = false;
  streetTypes: CodeName[] = [];

  userLogued: any;

  newVehicle: VehicleRquest = {
    vehiclePlate: '',
    vehicleAlias: '',
    ownerDeclaration: false
  }

  newException: ExceptionCreate = {
    type: {
      code: 'FOREIGN'
    },
    type_foreign: {
      classification: {
        code: ''
      },
      fuel: {
        code: ''
      },
      year: 2000
    },
    municipality: '',
    municipalities: [],
    attachments: [],
    flags: {
      email: this.applicant.flags!.email,
      sms: this.applicant.flags!.sms,
      personal: this.applicant.flags!.personal,
      privacity: this.applicant.flags!.privacity,
      veracity: this.applicant.flags!.veracity,
      protection: this.applicant.flags!.protection,
      vehicleDocumentation: this.applicant.flags!.vehicleDocumentation
    }
  }

  vehiclesTypes: VehicleType[] = [];
  municipalitiesMan: Municipality[] = [];
  classifications: CodeName[] = [];
  fuels: CodeName[] = [];

  constructor(
    private applicantsService: ApplicantsService,
    private countriesService: CountriesService,
    private municipalitiesService: MunicipalitiesService,
    private provincesService: ProvincesService,
    private router: Router,
    private readonly loaderService: LoaderService,
    private readonly alertService: AlertService,
    private readonly authService: AuthService,
    private readonly dialogService: DialogService,
    private exceptionsService: ExceptionsService,
    private vehiclesService: VehiclesService
  ) {
    this.applicantsService.getRelationships().subscribe(
      data => {
        this.relationships = data.relationships;
      }
    );
    this.countriesService.getCountries().subscribe(
      data => {
        this.countries = data.countries;
      }
    );
    this.provincesService.getProvinces().subscribe(
      data => {
        this.provinces = data.provinces;
      }
    );
    this.exceptionsService.getSteetTypes().subscribe(
      data => {
        this.streetTypes = data.streets;
      }
    );
    this.vehiclesService.getClassifications().subscribe(
      data => {
        this.classifications = data.classifications;
      }
    );
    this.vehiclesService.getFuels().subscribe(
      data => {
        this.fuels = data.fuels;
      }
    );
    this.vehiclesService.getVehicleTypes().subscribe(
      data => {
        this.vehiclesTypes = data.registrations;
      }
    );
    this.municipalitiesService.getMunicipalities().subscribe((data) => {
      this.municipalitiesMan = data.municipalities;
    });
    this.clearOtherForms();
  }

  async ngOnInit() {
    try {
      const userLogued = await this.authService.getUser();
      this.userLogued = userLogued;
      if (userLogued) {
        this.applicantsService.getCurrentApplicant().subscribe({
          next: applicant => {
            this.router.navigate(['/vehicles']);
          },
          error: error => {
            this.loadUserLogued();
          }
        });
      }
    } catch (error) {
      console.error('Error al obtener el usuario logueado:', error);
    }
  }

  async loadUserLogued() {
    // set default values
    this.applicant.applicantType = 'Individual';
    this.applicant.individual = {
      applicantIdentification: {
        name: this.userLogued.aoc.user.name,
        firstSurname: this.userLogued.aoc.user.surnames.split(' ')[0],
        secondSurname: this.userLogued.aoc.user.surnames.split(' ')[1],
        dateOfBirth: {
          date: ""
        } as RequestDate,
        documentType: "NIF",
        documentIdentification: this.userLogued.aoc.user.identifier
      } as ApplicantIndividualIdentification,
      applicantContact: {
        countryCode: 0,
        phoneNumber: "",
        province: "",
        municipality: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        door: "",
        stairCase: "",
        block: "",
        postalCode: "",
        email: ""
      } as ApplicantIndividualContact
    } as ApplicantIndividual;
  }

  checkValid() {
    this.isValid = false;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        this.applicant.identifier = this.applicant.individual!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.individual?.applicantIdentification.name !== "" &&
          this.applicant.individual?.applicantIdentification.firstSurname !== "" &&
          this.applicant.individual?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.individual?.applicantIdentification.documentType !== "" &&
          this.applicant.individual?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.individual?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&
          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&
          (this.applicant.flags?.privacity || false)
          ;
        break;
      case 'Company':
        this.applicant.identifier = this.applicant.company!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.company?.applicantIdentification.name !== "" &&
          this.applicant.company?.applicantIdentification.firstSurname !== "" &&
          this.applicant.company?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.company?.applicantIdentification.documentType !== "" &&
          this.applicant.company?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.company?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&

          this.applicant.company?.identification.documentIdentification !== "" &&
          this.applicant.company?.identification.documentType !== "" &&
          this.applicant.company?.identification.registeredName !== "" &&

          this.applicant.company?.relationship !== "" &&
          this.applicant.company?.representativeIdentification.name !== "" &&
          this.applicant.company?.representativeIdentification.firstSurname !== "" &&
          this.applicant.company?.representativeIdentification.dateOfBirth.date !== "" &&
          this.applicant.company?.representativeIdentification.documentType !== "" &&
          this.applicant.company?.representativeIdentification.documentIdentification !== "" &&

          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&

          (this.applicant.flags?.privacity || false)
          ;
        break;
      case 'Represented':
        this.applicant.identifier = this.applicant.represented!.applicantIdentification.documentIdentification;
        this.isValid =
          this.applicant.represented?.applicantIdentification.name !== "" &&
          this.applicant.represented?.applicantIdentification.firstSurname !== "" &&
          this.applicant.represented?.applicantIdentification.dateOfBirth.date !== "" &&
          this.applicant.represented?.applicantIdentification.documentType !== "" &&
          this.applicant.represented?.applicantIdentification.documentIdentification !== "" &&
          this.applicant.represented?.applicantContact.email !== "" &&
          this.confirmEmail !== "" &&

          this.applicant.represented?.relationship !== "" &&
          this.applicant.represented?.representativeIdentification.name !== "" &&
          this.applicant.represented?.representativeIdentification.firstSurname !== "" &&
          this.applicant.represented?.representativeIdentification.dateOfBirth.date !== "" &&
          this.applicant.represented?.representativeIdentification.documentType !== "" &&
          this.applicant.represented?.representativeIdentification.documentIdentification !== "" &&

          this.password !== "" &&
          this.password2 !== "" &&
          this.password === this.password2 &&

          (this.applicant.flags?.privacity || false)
          ;
        break;
    }
  }

  clearOtherForms() {
    this.isValid = false;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        this.applicant.individual = {
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact
        } as ApplicantIndividual;
        this.applicant.company = undefined;
        this.applicant.represented = undefined;
        break;
      case 'Company':
        this.applicant.individual = undefined;
        this.applicant.company = {
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          identification: {
            documentIdentification: "",
            documentType: "",
            registeredName: ""
          } as ApplicantOrganisationIdentification,
          relationship: "",
          representativeContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: "",
          } as ApplicantIndividualContact,
          representativeIdentification: {
            name: "",
            firstSurname: "",
            secondSurname: "",
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "",
            documentIdentification: ""
          } as ApplicantIndividualIdentification
        };
        this.applicant.represented = undefined;
        break;
      case 'Represented':
        this.applicant.individual = undefined;
        this.applicant.company = undefined;
        this.applicant.represented = {
          applicantContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          applicantIdentification: {
            name: this.userLogued?.aoc.user.name,
            firstSurname: this.userLogued?.aoc.user.surnames.split(' ')[0],
            secondSurname: this.userLogued?.aoc.user.surnames.split(' ')[1],
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "NIF",
            documentIdentification: this.userLogued?.aoc.user.identifier
          } as ApplicantIndividualIdentification,
          relationship: "",
          representativeContact: {
            countryCode: 0,
            phoneNumber: "",
            province: "",
            municipality: "",
            streetName: "",
            streetNumber: "",
            floor: "",
            door: "",
            stairCase: "",
            block: "",
            postalCode: "",
            email: ""
          } as ApplicantIndividualContact,
          representativeIdentification: {
            name: "",
            firstSurname: "",
            secondSurname: "",
            dateOfBirth: {
              date: ""
            } as RequestDate,
            documentType: "",
            documentIdentification: ""
          } as ApplicantIndividualIdentification
        };
        break;
    }
  }

  async initRegister() {
    if (!this.isValid) {
      return;
    }
    if (!this.applicant.flags!.email) {
      this.alertService.setAlert({
        message: $localize`:@@Register.EmailRequired:Debe seleccionar el email como medio de comunicación`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    this.loaderService.show();
    switch (this.applicant?.applicantType) {
      case 'Individual':
        this.user = this.applicant.individual!.applicantIdentification.documentIdentification;
        this.email = this.applicant.individual!.applicantContact.email;
        break;
      case 'Company':
        this.user = this.applicant.company!.applicantIdentification.documentIdentification;
        this.email = this.applicant.company!.applicantContact.email
        break;
      case 'Represented':
        this.user = this.applicant.represented!.applicantIdentification.documentIdentification;
        this.email = this.applicant.represented!.applicantContact.email;
        break;
    }
    const response = this.applicantsService.requestCodeRegister({
      identifier: this.user,
      password: this.password,
      email: this.email
    });

    if (response) {
      this.dialogService.setDialog({
        title: $localize`:@@Register.Dialog.Title:Código de verificación`,
        message: $localize`:@@Register.Dialog.Message:Se ha enviado un código de verificación a su email. Introduzca el código a continuación.`,
        input: true,
        button1Text: $localize`:@@Register.Dialog.Accept:Aceptar`,
        button2Text: $localize`:@@Register.Dialog.Cancel:Cancelar`,
        button1Callback: this.register2,
        button2Callback: () => {
          this.loaderService.hide();
        }
      });
    } else {
      this.loaderService.hide();
      this.alertService.setAlert({
        message: $localize`:@@Register.Error:Error al crear el usuario`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
    }
    this.loaderService.hide();
  }

  register2(code: string) {
    if (code === null) {
      this.loaderService.hide();
      return;
    }
    const response2 = this.applicantsService.requestCodeRegister({
      identifier: this.user,
      password: this.password,
      email: this.email,
      confirmationCode: code
    });
    if (response2) {
      this.authService.loginUser(this.user, this.password).then((success) => {
        if (success) {
          this.createApplicant();
        } else {
          this.loaderService.hide();
          this.alertService.setAlert({
            message: $localize`:@@Register.Error:Error al crear el usuario`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 2000
          });
        }
      });
    } else {
      this.loaderService.hide();
      this.alertService.setAlert({
        message: $localize`:@@Register.Error:Error al crear el usuario`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
    }
  }

  // Track which fields have been touched
  touchedFields: { [key: string]: boolean } = {};
  formSubmitted = false;

  // Method to check if a field is valid
  isFieldValid(value: any): boolean {
    return value !== undefined && value !== null && value !== '';
  }

  // Mark a field as touched when user interacts with it
  markAsTouched(fieldName: string): void {
    this.touchedFields[fieldName] = true;
  }

  // Check if field should show error
  shouldShowError(fieldName: string, value: any): boolean {
    return (this.touchedFields[fieldName] || this.formSubmitted) && !this.isFieldValid(value);
  }

  createApplicant() {
    this.formSubmitted = true;

    if (!this.isValid) {
      // Find all required fields that are empty
      const emptyFields: string[] = [];
      
      switch (this.applicant?.applicantType) {
        case 'Individual':
          // Check individual fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
        case 'Company':
          // Check company fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
        case 'Represented':
          // Check represented fields and add to emptyFields if needed
          // ... existing validation logic ...
          break;
      }
      
      this.alertService.setAlert({
        message: $localize`:@@Register.Required:Rellene todos los campos requeridos`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 5000
      });
      return;
    }
    this.loaderService.show();
    let validEmail = false;
    let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    switch (this.applicant?.applicantType) {
      case 'Individual':
        if (this.applicant.individual && this.applicant.individual.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.individual.applicantContact.email;
        break;
      case 'Company':
        if (this.applicant.company && this.applicant.company.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.company.applicantContact.email;
        break;
      case 'Represented':
        if (this.applicant.represented && this.applicant.represented.applicantContact.email.match(emailRegex))
          validEmail = this.confirmEmail === this.applicant.represented.applicantContact.email;
        break;
    }
    // ya comprobado anteriormente
    // if (!this.applicant.flags!.email && !this.applicant.flags!.sms) {
    //   this.alertService.setAlert({
    //     message: $localize`:@@Profile.NoCommunication:Debe seleccionar al menos un medio de comunicación.`,
    //     type: AlertType.Error,
    //     dismissible: true,
    //     dismissOnTimeout: 2000
    //   });
    //   return;
    // }
    if (validEmail) {
      this.applicant.password = this.password;
      this.applicantsService.registerForeignApplicant({
        applicant: this.applicant,
        vehicle: this.newVehicle,
        exception: this.newException
      }).subscribe(
        data => {
          this.loaderService.hide();
          this.alertService.setAlert({
            message: $localize`:@@Register.Created:Usuario creado correctamente`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 2000
          });
          this.router.navigate(['/login']);
        }
      );
    } else {
      this.loaderService.hide();
      this.alertService.setAlert({
        message: $localize`:@@Register.EmailError:Los emails son incorrectos`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
    }
  }

  loadMunicipalities() {
    let province = '';
    switch (this.applicant?.applicantType) {
      case 'Individual':
        province = this.applicant.individual!.applicantContact.province;
        break;
      case 'Company':
        province = this.applicant.company!.applicantContact.province;
        break;
      case 'Represented':
        province = this.applicant.represented!.applicantContact.province;
        break;
    }
    this.municipalitiesService.getMunicipalitiesByProvince(province).subscribe(
      data => {
        this.municipalities = data.municipalities;
      }
    );
  }

  register() {
    this.applicantsService.createApplicant(this.applicant).subscribe(
      data => {
        console.log(data);
        this.router.navigate(['/login']);
      }
    );
  }

  async loadFile(event: any) {
    this.newException.attachments = [
      {
        name: event.name,
        description: '',
        mime: event.type,
        data: await AttachmentUtil.arrayBufferToString(event.arrayBuffer())
      }
    ];
  }
}